import React from "react";
import SvgIcon from "../../assets/icons/capabilities-stack-1.svg";
import icon1 from "../../assets/icons/capabilities-stack-icon-1.png";
import icon2 from "../../assets/icons/capabilities-stack-icon-2.png";
import icon3 from "../../assets/icons/capabilities-stack-icon-3.png";
import icon4 from "../../assets/icons/capabilities-stack-icon-4.png";
import icon5 from "../../assets/icons/capabilities-stack-icon-5.png";
import Arrow from "../../components/Arrow";
const CapablitiesStack = () => {
  const data = [
    {
      header: "Development Strategy Consulting",
      data: "Time-bound consulting on a specific set of deliverables e.g. design a candidate to clinical Proof of Concept development plan ",
      icon: (
        <img src={icon1} alt="A graph line going up" className="h-[1.375rem]" />
      ),
    },
    {
      header: "Preclinical & Clinical Study Planning",
      data: "Design of clinical and Investigational New Drug (IND) enabling preclinical studies ",
      icon: <img src={icon2} alt="A stethoscope" className="h-[1.375rem]" />,
    },
    {
      header: "Vendor ID & Procurement Support",
      data: "Identify vendors and support procurement, leveraging our strategic external partners",
      icon: <img src={icon3} alt="Three people" className="h-[1.375rem]" />,
    },
    {
      header: "Study Support​",
      data: "Ongoing strategic and/or operational support throughout the development program",
      icon: <img src={icon4} alt="Two document" className="h-[1.375rem]" />,
    },
    {
      header: "Execution Management",
      data: "Manage an entire study or development plan",
      icon: (
        <img
          src={icon5}
          alt="Outline of a person with a lock next to them"
          className="h-[1.375rem]"
        />
      ),
    },
  ];
  return (
    <div className="grid lg:grid-cols-2 gap-4 items-center">
      <div className="lg:hidden">
        <div className="flex justify-center mb-8">
          <div
            className="border border-border-gray90 rounded-full p-4 max-w-60 text-center text-sm font-semibold"
            style={{ boxShadow: "4px 4px #FBCFC8" }}
          >
            Integrated Development Solutions
          </div>
        </div>

        <div className="h-full w-full flex justify-center">
          {/* <SvgIcon /> */}
          <img
            src={SvgIcon}
            alt="Diagram showing a layered capability model with multiple stacked levels representing business and system capabilities, illustrating how higher-level capabilities depend on underlying foundational layers, with related configuration code displayed alongside."
          />
        </div>
      </div>
      <div>
        {data.map((el, index) => (
          <div
            className="border border-border-gray90 rounded-[8px] p-4 my-6"
            style={{ boxShadow: "4px 4px #FBCFC8" }}
            id={`box-${index + 1}-text`}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-medium mb-2">{el.header}</h3>
              <div>{el.icon}</div>
            </div>
            <div>{el.data}</div>
          </div>
        ))}
      </div>
      <div className="lg:block hidden">
        <div className="flex justify-center mb-8">
          <div
            className="border border-border-gray90 rounded-full p-4 max-w-60 text-center text-sm font-semibold"
            style={{ boxShadow: "4px 4px #FBCFC8" }}
          >
            Integrated Development Solutions
          </div>
        </div>

        <div className="h-full w-full flex justify-center">
          {/* <SvgIcon /> */}
          <img
            src={SvgIcon}
            alt="Diagram showing a layered capability model with multiple stacked levels representing business and system capabilities, illustrating how higher-level capabilities depend on underlying foundational layers, with related configuration code displayed alongside."
          />
        </div>
      </div>
      {/* <Arrow toId="box1" fromId="box-1-text" dashed fromMiddle />
      <Arrow toId="box2" fromId="box-2-text" dashed fromMiddle />
      <Arrow toId="box3" fromId="box-3-text" dashed fromMiddle />
      <Arrow toId="box4" fromId="box-4-text" dashed fromMiddle />
      <Arrow toId="box5" fromId="box-5-text" dashed fromMiddle /> */}
    </div>
  );
};

export default CapablitiesStack;
